import {AppRoute} from './common';

const BASE_URL = 'https://it-tz.ru';

export const ExternalLinks = {
  Telegram: '/#',
  WhatsApp: '/#',

  InfoEmail: 'mailto:info@it-tz.ru',
}

export const PageTitle = {
  Main: 'TaskStore - большой каталог готовых ТЗ для IT-сферы по выгодным ценам',
  Catalog: 'Каталог | TaskStore',
  Error: 'Страница не найдена | TaskStore',
  Privacy: 'Политика конфиденциальности | TaskStore',
  Profile: 'Профиль | TaskStore',
  PurchaseHistory: 'История покупок | TaskStore',
  Search: 'Результаты поиска | TaskStore',
  Blog: 'Статьи о разработке готовых ТЗ: составление и внедрение в проект ',
  Article: 'Статья | TaskStore',
}
export const PageDesc = {
  Main: 'TaskStore - это интернет-магазин с широким ассортиментом уже готовых технических заданий в для любой IT-сферы. Покупайте индивидуальные ТЗ или на заказ. Полный спектр предложений: от проектирования до создания и внедрения',
  Blog: 'Читайте интересные статьи о составлении готовых технических заданий для программистов и веб-разработчиков. Узнайте советы и рекомендации от наших экспертов, а также найдите для себя подробные инструкции ',
}

export const CanonicalUrl = {
  Main: `${BASE_URL}${AppRoute.Root}`,
  Privacy: `${BASE_URL}${AppRoute.Privacy}`,
  Profile: `${BASE_URL}${AppRoute.Profile}`,
  PurchaseHistory: `${BASE_URL}${AppRoute.PurchaseHistory}`,
  Blog: `${BASE_URL}${AppRoute.Blog}`,
  Search: `${BASE_URL}${AppRoute.Search}`,
};
